import React, { Component } from 'react';
// import ImgProfile from '../assets/img/theme/team-4-800x800.jpg'
import { confirmAlert } from 'react-confirm-alert'; // Import
import 'react-confirm-alert/src/react-confirm-alert.css'; // Import css
// import { Button } from 'react-bootstrap';
// import { Alert } from 'react-bootstrap';
import {
    Link, 
    Redirect
} from 'react-router-dom'
import {NotificationContainer, NotificationManager} from 'react-notifications';
import 'react-notifications/lib/notifications.css';
import axios from 'axios'
import Base from '../Config'


class DropDownMenu extends Component {
  
    constructor() {
        super();
        const token = localStorage.getItem('Token')
        let loggedIn=true
        if(token == null){
          loggedIn=false
        }
        this.state = {
          loggedIn,
          loggedOut:false
        };
        
        this.logout = this.logout.bind(this)
      }
      submit = () => {
        confirmAlert({
          title: 'Logging out',
          message: 'Are you sure ?',
          buttons: [
            {
                label: 'Yes',
                onClick: () => {
                this.setState({
                    loggedIn:false,
                    loggedOut:true
                })
                var userId = localStorage.getItem('userId')
                // console.log("userId : ",userId)
                this.removeAdminToken(userId)
                localStorage.removeItem('Token')

                }
            },
            {
                label: 'No',
                onClick: () => {
                  //nothing
                }
            }
          ]
        });
      }

      removeAdminToken=(token)=>{
        // console.log('token ',token);
        
        // return false 
        axios.delete(
            Base.url + 'AdminNotificationTokens/?token='+token,
            {
                headers: {
                    'Authorization': 'Token ' + localStorage.getItem('Token'),
                }
            }
        )
        .then(response =>{
            // console.log('response : ',response.data.Message);
        })
        .catch(error=>{
            console.log(error);
        })
    }
    
    
      logout(){
        
        this.submit()


      }
    
      render() {
        if(this.state.loggedOut===true){
            return <Redirect to='/login'/>  
        }
        if(this.state.loggedIn === false){
          NotificationManager.info('Info : ','Please login first', 3000)

          return <Redirect to='/login'/>
        }
        const menu = {
            // color: "white",
            // backgroundColor: "DodgerBlue",
            // padding: "10px",
            // fontFamily: "Arial"
          };

        return (
          <div>
           {/* <i className="fas fa-sign-out-alt fa-2x logout " onClick={this.logout} ></i> */}
           <i className="fas fa-sign-out-alt fa-2x logout "  onClick={this.logout} ></i>
          </div>
        );
      }
}

export default class PageHeader extends Component {
    render() {
        return (
            <nav className="navbar navbar-top navbar-expand-md navbar-dark" id="navbar-main">
                <div className="container-fluid">
                    <NotificationContainer/>
                    {/* Brand */}
                    <label className="h4 mb-0 text-white text-uppercase d-none d-lg-inline-block" >{this.props.pageName?this.props.pageName:"undefined"}</label>
                    {/* Form */}
                    {/* User */}
                    <ul className="navbar-nav align-items-center d-none d-md-flex">
                        <li className="nav-item dropdown">

                            {/* <a className="nav-link pr-0" href="#" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"> */}
                                <div className="media align-items-center">
                                    <Link href="#" to="/profile" className="avatar avatar-sm rounded-circle">
                                      <i className="fa fa-user" aria-hidden="true"></i>
                                      
                                    </Link>
                                    <a href="#" className="nav-link pr-0 media-body ml-2 d-none d-lg-block">
                                        <span className="mb-0 text-sm  font-weight-bold">
                                        <DropDownMenu/>
                                        </span>
                                    </a>
                                </div>

                                <div style={{color:'#fff', display:'flex', justifyContent:'center '}}>v 1.0</div>

                            {/* </a> */}
                        </li>
                    </ul>
                </div>
            </nav>
        );
    }
}
